import React from 'react';

/**
 * Card — elevated surface. Compose with Card.Header / Body / Footer.
 *
 * Props:
 *   variant: 'default' | 'flat' | 'inset'
 */
const Card = ({ variant = 'default', className = '', children, ...rest }) => {
  const variantClass = variant === 'flat' ? 'ps-card--flat' : variant === 'inset' ? 'ps-card--inset' : '';
  return (
    <div className={`ps-card ${variantClass} ${className}`.trim()} {...rest}>
      {children}
    </div>
  );
};

const CardHeader = ({ className = '', children, ...rest }) => (
  <div className={`ps-card__header ${className}`.trim()} {...rest}>{children}</div>
);

const CardTitle = ({ as: Component = 'h3', className = '', children, ...rest }) => (
  <Component className={`ps-card__title ${className}`.trim()} {...rest}>{children}</Component>
);

const CardSubtitle = ({ className = '', children, ...rest }) => (
  <p className={`ps-card__subtitle ${className}`.trim()} {...rest}>{children}</p>
);

const CardBody = ({ className = '', children, ...rest }) => (
  <div className={`ps-card__body ${className}`.trim()} {...rest}>{children}</div>
);

const CardFooter = ({ className = '', children, ...rest }) => (
  <div className={`ps-card__footer ${className}`.trim()} {...rest}>{children}</div>
);

Card.Header = CardHeader;
Card.Title = CardTitle;
Card.Subtitle = CardSubtitle;
Card.Body = CardBody;
Card.Footer = CardFooter;

export { CardHeader, CardTitle, CardSubtitle, CardBody, CardFooter };
export default Card;
